<template>
  <el-dialog :close-on-click-modal="false"
             v-bind="$attrs"
             v-on="$listeners"
             :title="title"
             @open="open"
             @closed="closed"
             width="1000px">
    <div v-loading="!work" style="height: 500px">
      <el-tabs v-model="activeName" @tab-click="clickTab" v-if="work">
        <el-tab-pane name="basic">
          <template #label>
            <label style="padding: 0 50px; cursor: pointer">工单基本信息</label>
          </template>
          <basic-work-pane2 :pattern="subPattern" :work="work" ref="basicPane"></basic-work-pane2>
        </el-tab-pane>
        <el-tab-pane name="loss">
          <template #label>
            <label style="padding: 0 50px; cursor: pointer">维修信息</label>
          </template>
          <loss-determ-panel v-loading="procedureLoading"
                             :pattern="subPattern"
                             :loss-determ="work.lossDeterm"
                             :work="work">
          </loss-determ-panel>
        </el-tab-pane>
        <el-tab-pane name="opera-record">
          <template #label>
            <label style="padding: 0 50px; cursor: pointer">操作记录</label>
          </template>
          <opera-record-panel :records="operaRecords"></opera-record-panel>
        </el-tab-pane>
      </el-tabs>
    </div>
    <template #footer>
      <div style="display: flex;">
        <el-button v-DELETE_WORK v-show="!isReadOnly" type="danger" @click="deleteWork" :disabled="!work">删 除
        </el-button>
        <div style="flex-grow: 1"></div><!-- flex 占位 -->
        <el-button type="primary" v-show="!isReadOnly && !isEdit" @click="isEdit = true" :disabled="!work">
          {{isEditable ? '编 辑' : '编辑&增项'}}
        </el-button>
        <el-button v-show="isEdit" type="primary" @click="save()">保 存</el-button>
        <el-button v-if="!isEdit" @click="print" :disabled="!work">打 印</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </template>
    <div v-show="false" v-if="work">
      <el-button v-print="printTarget" ref="printTrigger"></el-button>
      <print-work id="printContent2" :work="work" ref="print"></print-work>
    </div>
  </el-dialog>
</template>

<script>
  import { addParts2Work, deleteWork, getWorkDetail, updateWork, workOperaRecord } from '@/utils/request'
  import LossDetermPanel from '@/views/kanban/dialog/add-check/LossDetermPanel'
  import PrintWork from '@/views/kanban/dialog/add-check/PrintWork'
  import BasicWorkPane2 from '@/views/kanban/dialog/add-check/BasicWorkPane2'
  import OperaRecordPanel from '@/views/kanban/dialog/add-check/OperaRecordPanel'

  export default {
    name: 'DetailWorkDialog',
    components: {
      OperaRecordPanel,
      BasicWorkPane2,
      PrintWork,
      LossDetermPanel
    },
    props: {
      workId: {
        type: String,
        required: true
      },
      pattern: {
        type: String, // 'READ_WORK', 'READ_EDIT_WORK', 'READ_ADD_PARTS'
        required: true
      }
    },
    data () {
      return {
        activeName: 'basic',
        work: null,
        isEdit: false,
        printTarget: {
          id: 'printContent2',
          popTitle: null
        },
        operaRecords: [],
        procedureLoading: false
      }
    },
    methods: {
      hide () {
        this.$emit('update:visible', false)
      },
      clickTab () {
        if (this.activeName === 'basic') return

        this.workRef.validate(valid => {
          if (!valid) {
            this.$message.warning('请先完成基本信息填写')
            this.$nextTick(() => {
              this.activeName = 'basic'
            })
          }
        })
      },
      deleteWork () {
        this.$confirm(`确认删除车牌号【${this.work.carNo}】的工单, 是否继续?`, '提示', {
          confirmButtonText: '删除',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          deleteWork(this.workId).then(() => {
            this.hide()
            this.$message.success('删除成功!')
          })
        }).catch(() => {
        })
      },
      cancel () {
        this.hide()
      },
      save () {
        debugger
        var ban = false
        this.workRef.validate(valid => {
          if (!valid) {
            this.$message.warning('请先完成基本信息填写')
            ban = true
          }
        })
        if (ban) return
        if (this.isEditable) {
          if (this.work.lossDeterm.partsList.length === 0) {
            this.$message.warning('请选择需要维修的部位')
            return
          }
          updateWork(this.$_.cloneDeep(this.work)).then(() => {
            this.$emit('loading')
            this.hide()
          })
        } else {
          this.work.lossDeterm.partsList.forEach(parts => delete parts.fixed)
          addParts2Work(this.$_.cloneDeep(this.work)).then(() => {
            this.$emit('loading')
            this.hide()
          })
        }
      },
      print () {
        this.$refs.printTrigger.$el.click()
      },
      open () {
        getWorkDetail(this.workId).then(work => {
          this.work = work
          if (this.isAddable) {
            this.work.lossDeterm.partsList.forEach(parts => {
              parts.fixed = true
            })
          }
        })
        workOperaRecord(this.workId).then(response => {
          this.operaRecords = response.data
        })
        this.procedureLoading = true
        this.$store.dispatch('procedure/middleProcedureList').then(() => {
          this.procedureLoading = false
        })
        this.printTarget.popTitle = '工单: ' + this.workId
      },
      closed () {
        this.work = null
        this.workRef.resetFields()
        this.isEdit = false
        this.activeName = 'basic'
        this.operaRecords = []
      }
    },
    computed: {
      title () {
        if (!this.isEdit) {
          return '查看工单'
        }
        return this.isEditable ? '编辑工单' : '编辑&增项'
      },
      subPattern () {
        if (!this.isEdit) {
          return 'READ'
        }
        return this.isEditable ? 'EDIT' : 'ADD_PARTS_IN_WORK'
      },
      workRef () {
        return this.$refs.basicPane.$refs.work
      },
      isReadOnly () {
        return this.pattern === 'READ_WORK'
      },
      isEditable () {
        return this.pattern === 'READ_EDIT_WORK'
      },
      isAddable () {
        return this.pattern === 'READ_ADD_PARTS'
      }
    }
  }
</script>
